import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=806cb530&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('806cb530')) {
      api.createRecord('806cb530', component.options)
    } else {
      api.reload('806cb530', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=806cb530&", function () {
      api.rerender('806cb530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26jlLO5SEQX33/JS/offershelp.vue"
export default component.exports